
import React from 'react';
import AdminMediaManagement from '@/components/admin/AdminMediaManagement';

const AdminMediaPage = () => {
  
  return <AdminMediaManagement />;
};

export default AdminMediaPage;
